import { Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'cuit'})
export class CuitPipe implements PipeTransform {
    private SEPARATOR: string;
    constructor() {
        this.SEPARATOR = '-';
    }
    transform(value: number | string): string {
        const fractionSize = 12;
        let [ integer, fraction = '', last = '' ] = (value || '').toString()
            .split(this.SEPARATOR);
        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/, this.SEPARATOR);
        fraction = (integer).substring(3, fractionSize);
        last = (fraction.substring(8, 9));
        fraction = (integer).substring(3, fractionSize - 1);
        fraction = fraction + '-' + last;
        integer = integer.substring(0, 3);
        return integer + fraction;
}
    parse(value: string): string {
        let cadena = '';
        const arr = value.split(this.SEPARATOR);
        arr.forEach(x => {
            cadena = cadena + x;
        });
        cadena = cadena.replace('-', '');
        return cadena;
    }
}
